import { render, staticRenderFns } from "./QProgressStat.vue?vue&type=template&id=2e40987d&scoped=true&"
import script from "./QProgressStat.vue?vue&type=script&lang=js&"
export * from "./QProgressStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e40987d",
  null
  
)

export default component.exports